import { ResultTabsService } from '@services/results/result-tabs.service';
import { ResultsetErrorsStoreService } from '@services/notifications/resultset-errors-store.service';
import { Component, AfterViewInit, OnInit, OnDestroy } from '@angular/core';
import { NotificationsService } from '@services/notifications/notifications.service';
import { Notification } from '@models/notification';
import { ResultsService } from '@services/results/results.service';
import { fromEvent } from 'rxjs';
import { isEmpty } from '@shared/helpers/arrays';
import { ResultSetError } from '@models/results/results-class-library';

@Component({
  selector: 'app-results-notification-badge',
  templateUrl: './notification-badge.component.html',
  styleUrls: ['./notification-badge.component.scss']
})
export class NotificationBadgeComponent implements OnInit, AfterViewInit, OnDestroy {
  public notificationListVisible = false;
  public currentNotifications;
  public cellErrorNotifications;
  public newDataNotification;
  public resultsNotifications;
  public activeTab;
  private mouseTracker;
  public resultsetOODNotifications;

  constructor(
    private notifications: NotificationsService,
    private resultService: ResultsService,
    private resultsetErrors: ResultsetErrorsStoreService,
    private resultTabs: ResultTabsService
  ) {}

  ngOnInit() {
    this.notifications.notificationList$.subscribe(notifications => {
      this.resultsNotifications = this.notifications.getNotificationListByType('resultError');
      this.cellErrorNotifications = this.notifications.getNotificationListByType('cellError');
      this.newDataNotification = this.notifications.getNotificationListByType('dataImportRequired');
      this.resultsetOODNotifications = this.notifications.getNotificationListByType('resultset-ood');
      const activeTab = this.resultTabs.activeView;

      const map = this.filterResultsByMnemonic(activeTab ? activeTab.tabName : '', this.resultsNotifications);
      this.resultsNotifications = new Map<number, Notification>(map);

      const oodsMap = this.filterResultsByMnemonic(activeTab ? activeTab.tabName : '', this.resultsetOODNotifications);
      this.resultsetOODNotifications = new Map<number, Notification>(oodsMap);

      this.mergeNotifications();
    });

    this.resultTabs.activeView$.subscribe(activeView => {
      const tabName = activeView.tabName;

      const resultErrorsNotifications = this.notifications.getNotificationListByType('resultError');
      const resultsMap = this.filterResultsByMnemonic(tabName, resultErrorsNotifications);
      this.resultsNotifications = new Map<number, Notification>(resultsMap);

      const oodNotifications = this.notifications.getNotificationListByType('resultset-ood');
      const oodsMap = this.filterResultsByMnemonic(tabName, oodNotifications);
      this.resultsetOODNotifications = new Map<number, Notification>(oodsMap);

      this.mergeNotifications();
    });
  }

  ngAfterViewInit() {
    this.mouseTracker = fromEvent(document, 'click').subscribe((e: MouseEvent) => {
      if (!(<HTMLInputElement>e.target).closest('.dropdown_container') && this.notificationListVisible) {
        this.notificationListVisible = false;
      }
    });
  }

  ngOnDestroy() {
    this.mouseTracker.unsubscribe();
  }

  private filterResultsByMnemonic(mnemonic, results) {
    if (mnemonic && mnemonic.length > 0) {
      return [...results].filter(([k, v]) => v.references.mnemonic === mnemonic);
    } else {
      return [...results].filter(([k, v]) => isEmpty(v.references.mnemonic));
    }
  }

  toggleNotificationDisplay() {
    this.notificationListVisible = !this.notificationListVisible;
  }

  public displayErrorsForSheet(references: { errorList: ResultSetError[] }, id: number) {
    // ! Fix 4868: Filter to display only those errors that belong to this sheet
    references.errorList =
      references.errorList && references.errorList.filter(ref => ref.mnemonic === this.resultTabs.activeView.tabName);
    this.toggleNotificationDisplay();
    this.resultsetErrors.currentSheetErrors$.next({
      id,
      references: references.errorList
    });
  }

  public rerunResultset() {
    this.toggleNotificationDisplay();
    this.notificationListVisible = false;
  }

  private mergeNotifications() {
    this.currentNotifications = new Map([
      ...this.resultsNotifications,
      ...this.cellErrorNotifications,
      ...this.newDataNotification,
      ...this.resultsetOODNotifications
    ]);
  }
}
